/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import SelectComponent from '../select/Select';
import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';
import HeaderComponent from '../table/header/headerComponent';
import FamiliesAction from '../../app/store/actions/categoryFamilies';
import VALIDATOR from '../../helpers/validator/formValidator';

class NewCategoryFamiliesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        id: '',
        codeFamily: '',
        categoryId: '',
      },
      codeFamilyDisabled: false,
      message: '',
      success: '',
    };
  }

  async componentDidMount() {
    const { search } = this.props.location;
    if (search) {
      const splited = search.split('=');
      const categoryFamily = this.props.categoryfamilies.rows.find(pl => `${pl.id}` === splited[1]);
      await this.setClientUpdate(categoryFamily);
    }
  }

  setClientUpdate = async (item) => {
    if (item) {
      const { form } = this.state;
      form.id = item.id;
      form.codeFamily = item.codeFamily;
      form.categoryId = item.categoryId;
      this.setState({
        message: '', success: '', form, codeFamilyDisabled: true,
      });
    }
  }

  goBack = () => history.push({
    pathname: ROUTES.PARAMETERS,
    page: 'families',
  });

  createFamily = async () => {
    const { form } = this.state;

    const valid = VALIDATOR.categoryFamilyValidator(form);
    if (valid.success) {
      try {
        const result = await this.props.createFamily(form);
        console.log(result);
        this.setState({
          message: '',
          success: 'Relacionamento criado com sucesso!',
          codeFamilyDisabled: false,
          form: {
            id: '',
            codeFamily: '',
            categoryId: '',
          },
        });
        this.goBack();
      } catch (error) {
        const errorData = !!(error.response && error.response.data);
        if (errorData) {
          this.setState({ message: error.response.data.error.message, success: '' });
        }
      }
    } else {
      this.setState({ message: valid.message, success: '', codeFamilyDisabled: false });
    }
  }

  updateFamily = async () => {
    const { form } = this.state;

    const valid = VALIDATOR.categoryFamilyValidator(form);
    if (valid.success) {
      await this.props.updateFamily(form);
      this.setState({ message: '', success: 'Relacionamento atualizado com sucesso!' });
    } else {
      this.setState({ message: valid.message, success: '' });
    }
  }

  getValuesCAtegory = values => (values.map(val => (
    <option key={`${val.id}_cat`} value={val.id}>
      {`${val.id} - ${val.name}`}
    </option>
  )));

  getValuesFamilyOptions = (index, id, name) => (
    <option key={`${index}_${id}`} value={id}>
      {`${id} - ${name}`}
    </option>
  );

  getValuesFamily = (values) => {
    const { rows } = this.props.categoryfamilies;
    const { id, codeFamily } = this.state.form;

    return (values.map((val, index) => {
      const noRegistered = !rows.find(row => row.codeFamily === val.id);
      const name = id === 1 ? I18n.t('nameDefault') : (val.descricao || '');
      if (rows.length > 1) {
        if (codeFamily) {
          return this.getValuesFamilyOptions(index, id === 1 ? codeFamily : val.id, name);
        }

        if (noRegistered) {
          return this.getValuesFamilyOptions(index, val.id, name);
        }
      }
      return this.getValuesFamilyOptions(index, val.id, name);
    }));
  };

  selectedItem = (attr, value) => {
    const { form } = this.state;
    form[attr] = value.target.value;

    this.setState({ form, message: '', success: '' });
  }

  getSelectComponent = (title, attr, value, body, tooltip, disabled = false) => (
    <SelectComponent
      title={title}
      value={value}
      body={body}
      onChange={e => this.selectedItem(attr, e)}
      tooltip={tooltip}
      disabled={disabled}
    />
  )

  render() {
    const {
      form,
      codeFamilyDisabled,
      message,
      success,
    } = this.state;
    const { id, codeFamily, categoryId } = form;
    const { families = [], categories = [] } = this.props;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('familyRegister')}
        />

        <div className="form-group search-custom-input">
          { families.length && this.getSelectComponent(
            I18n.t('family'),
            'codeFamily',
            codeFamily,
            this.getValuesFamily(families),
            '',
            codeFamilyDisabled,
          )}
          { categories.length && this.getSelectComponent(
            I18n.t('category'),
            'categoryId',
            categoryId,
            this.getValuesCAtegory(categories),
          )}

          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id
            ? (
              <button
                type="button"
                className="btn btn-dark margin"
                onClick={this.updateFamily}
              >
                <Translate value="update" />
              </button>
            )
            : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.createFamily}
              >
                <Translate value="register" />
              </button>
            )
          }
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateFamily: categoryFamily => dispatch(FamiliesAction.updateFamily(categoryFamily)),
  createFamily: categoryFamily => dispatch(FamiliesAction.createFamily(categoryFamily)),
});

const mapStateToProps = state => ({
  families: state.families && state.families.families,
  categories: state.families && state.families.categories,
  categoryfamilies: state.families && state.families.categoryfamilies,
});

export default connect(mapStateToProps, mapDispatchToProps)(NewCategoryFamiliesForm);
